import Vue from 'vue';
import App from './App.vue';
import router from './router';
import 'vant/lib/index.css';
import { Icon } from 'vant';

Vue.use(Icon);

// 添加定时刷新token的功能
// const refreshTokenInterval = 1000 * 60 * 20; // 20分钟刷新一次



new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
